import { ApiService } from '../common/serviceBase';
import { URL_REPORTS } from '../common/apiUrl';

export class RelatoriosService {
    constructor() {
        this.service = new ApiService(`${URL_REPORTS}/relatorios`);
    }

    async getAll() {
        const response = await this.service.get();
        return response.data;
    }

    async create(data) {
        const response = await this.service.post('', data);
        return response.data;
    }

    async remove(rti_id) {
        const response = await this.service.delete(rti_id);
        return response;
    }

    async get(rela_id) {
        const response = await this.service.get(rela_id);
        return response.data;
    }
}